import Vue from 'vue'

import PropertyCard from './property-card.vue'
import PropertiesCarousel from './properties-carousel.vue'
import { Location } from '../scripts/translate/location'
import { translator } from '../scripts/translate'

export const propertyCardsList = ({ el, mounted }) => {
  new Vue({
    el,
    mounted,
    components: {
      PropertyCard,
    },
  })
}

export const createPropertyMapPopupApp = ({ el, data }) => {
  new Vue({
    el,
    data() {
      return {
        properties: data?.properties,
      }
    },
    components: {
      PropertiesCarousel,
    },
    render(h) {
      return h('properties-carousel', {
        props: {
          properties: this.properties,
        },
      })
    },
    mounted() {
      const location = new Location(this.$el)
      translator.registerLocation('mapPopup', location)
      translator.refreshTranslation('mapPopup')
    },
  })
}
